export enum LocalStorageKeys {
    userPreferences = 'userPreferences',
}
